export default function prepareTextForSearch(text: string) {
    return text.toLowerCase().replace(/[!"#$%&'()*+,-.:;<=>?@[\]^_`{|}~]/g, '');
}